import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
export function FinalCtaSection() {
  return <section className="py-20 bg-[#0a0a0a] border-t border-gray-800" data-id="element-29">
      <div className="max-w-5xl mx-auto px-4" data-id="element-30">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-31">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2" data-id="element-32">
            <img src="https://cdn.magicpatterns.com/uploads/kkNrP6kP1NsDXr2EW8y3Hg/58162765-36da-4b64-b056-5d1a5558b1b1.png" alt="Tu cambio empieza acá" className="w-full h-auto rounded-lg shadow-2xl transform hover:scale-[1.02] transition-transform duration-500" data-id="element-33" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="w-full md:w-1/2 text-center md:text-left" data-id="element-34">
            <h2 className="text-3xl md:text-5xl font-black text-white mb-6 uppercase leading-tight" data-id="element-35">
              Tu cambio como ADC{' '}
              <span className="text-amber-500" data-id="element-36">empieza acá</span>
            </h2>
            <p className="text-red-400 font-bold text-sm uppercase tracking-widest mb-2 animate-pulse" data-id="element-37">
              🔥 Últimos días de descuento
            </p>
            <p className="text-gray-400 text-lg mb-8" data-id="element-38">
              No dejes pasar otra temporada estancado en el mismo lugar. Tomá
              acción hoy y empezá a ver resultados.
            </p>

            <div className="flex flex-col items-center md:items-start gap-6" data-id="element-39">
              <div className="text-4xl font-black text-white" data-id="element-40">
                $7.999{' '}
                <span className="text-xl text-gray-500 font-bold" data-id="element-41">ARS</span>
              </div>
              <CtaButton text="COMPRAR AHORA" subtext="Formato digital – acceso inmediato" className="w-full" data-id="element-42" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}